import { Box, Typography, CircularProgress, useTheme } from '@mui/material'
import React, { useState } from 'react'
import { toast } from 'react-toastify'

import CustomSwitch from '../../common/CustomSwitch'
import api from '../../../service/api'


const DepartmentOrBranchPermission = ( { tabValue, record, group, feature_key, permission, refresh, id } ) => {

    const [updating, setUpdating] = useState( false )

    const { palette, border, layout } = useTheme()

    const updateOverrides = async ( event ) => {
        try {
            setUpdating( true )
            const payload = {
                feature_key,
                institute_id: record.code,
                override_type: tabValue,
                target_id: tabValue === "branches" ? group.course_branch_assignment_id : group.department_id,
                is_enabled: event.target.checked,
                update_type: "overrides"
            }

            await api.featurePermissions.updatePermissions( feature_key, payload )
            await refresh( false )
        } catch ( err ) {
            console.log( err )
            toast( err?.response?.data?.message || "Something went wrong while updating the override permission." )
        } finally {
            setUpdating( false )
        }
    }

    return (
        <Box padding="2px 5px" border={border[1]} borderColor={palette.text.secondary} borderRadius={layout.borderRadius} display="flex" justifyContent="space-between" gap="10px" alignItems="center">
            <Typography variant="subtitle2">{tabValue === "branches" ? `${group.course_name}-${group.course_branch_short_name}` : group.department_name}</Typography>
            {updating ? <CircularProgress color='greyed' size={20} /> : <CustomSwitch size="small" onChange={updateOverrides} checked={Boolean( permission )} />}
        </Box>
    )
}

export default DepartmentOrBranchPermission